export async function seasonPassInformation(seasonPass: number, bronze: number, silver: number, gold: number) {
    console.log("seasonPass: ", seasonPass)
    let rank = "Unranked"
    if (seasonPass <= bronze || seasonPass === 0){
         rank = "Unranked"
    }else if(seasonPass >= bronze && seasonPass < silver){
        rank = "Bronze"
    }else if(seasonPass >= silver && seasonPass < gold){
        rank = "Silver"
    }else if(seasonPass >= gold){
        rank = "Gold"
    }

    let nextRank = ""
    switch (rank) {
        case "Unranked":
            nextRank = "Bronze"
            break
        case "Bronze":
            nextRank = "Silver"
            break
        case "Silver":
            nextRank = "Gold"
            break
    }

    let currentRankIcon = ""
    switch (rank) {
        case "Unranked":
            currentRankIcon = "/Icon_TierBadge_Unranked.svg"
            break
        case "Bronze":
            currentRankIcon = "/Icon_TierBadge_Bronze.svg"
            break
        case "Silver":
            currentRankIcon = "/Icon_TierBadge_Silver.svg"
            break
        case "Gold":
            currentRankIcon = "/Icon_TierBadge_Gold.svg"
            break
        default:
            currentRankIcon = "unranked"
    }

    let creditsUntilPromotion
    switch (rank) {
        case "Unranked":
            creditsUntilPromotion = bronze - seasonPass
            break
        case "Bronze":
            creditsUntilPromotion = silver - seasonPass
            break
        case "Silver":
            creditsUntilPromotion = gold - seasonPass
            break
        case "Gold":
            creditsUntilPromotion = 0
            break
        default:
            creditsUntilPromotion = 0
    }

    const payload = {
        rank,
        nextRank,
        currentRankIcon,
        creditsUntilPromotion,
        bronze,
        silver,
        gold,
    }

    return payload
}

export async function nextRankIcon(rank: string) {
    switch (rank) {
        case "Unranked":
            return "/Icon_TierBadge_Bronze.svg"
        case "Brozne":
            return "/Icon_TierBadge_Silver.svg"
        case "Silver":
            return "/Icon_TierBadge_Gold.svg"
        case "Gold":
            return "Top Tier Achieved"
        default:
            return
    }
}
